import Filter from './modules/filter';
import Dropdown from './modules/dropdown';
import Accordion from './modules/accordion';
import Hero from './modules/hero';
import Navigation from './modules/navigation';
import Slider from './modules/slider';
import hScroller from './modules/horizontal-scroller';
import Timeline from './modules/timeline';
import Scroll from './modules/scroll';
import PostLooper from './modules/post-looper';
import Image from './modules/image';
import Anim from './modules/anim';

const _initDomReady= () => {
    document.body.classList.remove('no-js');
    Hero.init();
    Navigation.init();
    Scroll.init();
    Image.init();
    Timeline.init();
    Filter.init();
    Accordion.init();
    Dropdown.init();
    hScroller.init();
    Slider.init();
    PostLooper.init();
};

const _init = () => {
    Anim.init();
};

document.addEventListener('DOMContentLoaded', () => {
    _initDomReady();
});

window.addEventListener('load', () => {
    _init();
});